import React, { Component } from 'react'

export default class PendingWoReport extends Component {
  render() {
    return (
      <div>pendingWoReport</div>
    )
  }
}